import * as React from 'react';
import { SGBase, SGBaseProps } from './sgbase';

export enum ETranslationBehavior
{
	LockedToParent = 0,
	LockedToWorld = 1,
}

export interface ElasticHeadTransformProps extends SGBaseProps
{
	start_angle_threshold?: number; // Degrees user can look away without it moving.
	stop_angle_threshold?: number; // Degrees. Once transform is this close to look angle, it stops moving.
	ease_in_time?: number; // Seconds until we're fully eased in.
	ease_in_power?: number; // Ease in curve power.
	ease_out_angle_threshold?: number; // Degrees. Once transform is this close to look angle, it starts easing out.
	ease_out_power?: number; // Ease out curve power.
	min_angular_velocity?: number; // Minimum degrees/sec (at 0 degrees).
	max_angular_velocity?: number; // Maximum degrees/sec (at 180 degrees).
	lock_to_horizon?: boolean;
	translation_behavior?: ETranslationBehavior; // Behavior of this transform's translation.
}

declare global { namespace JSX {
	interface IntrinsicElements {
	  "vsg-elastic-head-transform": any;
	}
  }
}


export class ElasticHeadTransform extends SGBase<ElasticHeadTransformProps, null>
{
	constructor( props: any )
	{
		super( props );
	}

	public internalRender()
	{
		let fStartAngleThreshold = ( this.props.start_angle_threshold ? this.props.start_angle_threshold * Math.PI / 180 : null );
		let fStopAngleThreshold = ( this.props.stop_angle_threshold ? this.props.stop_angle_threshold * Math.PI / 180 : null );
		let fEaseOutAngleThreshold = ( this.props.ease_out_angle_threshold ? this.props.ease_out_angle_threshold * Math.PI / 180 : null );
		let fMinAngularVelocity = ( this.props.min_angular_velocity ? this.props.min_angular_velocity * Math.PI / 180 : null );
		let fMaxAngularVelocity = ( this.props.max_angular_velocity ? this.props.max_angular_velocity * Math.PI / 180 : null );

		return (
			<vsg-elastic-head-transform
				start-angle-threshold={ fStartAngleThreshold }
				stop-angle-threshold={ fStopAngleThreshold }
				ease-in-time={ this.props.ease_in_time }
				ease-in-power={ this.props.ease_in_power }
				ease-out-angle-threshold={ fEaseOutAngleThreshold }
				ease-out-power={ this.props.ease_out_power }
				min-angular-velocity={ fMinAngularVelocity }
				max-angular-velocity={ fMaxAngularVelocity }
				lock-to-horizon={ this.props.lock_to_horizon }
				translation-behavior={ this.props.translation_behavior }
				>
				{ this.props.children }
			</vsg-elastic-head-transform> );
	}
}

